import { render, staticRenderFns } from "./cgwcDetail.vue?vue&type=template&id=7b167874&scoped=true&"
import script from "./cgwcDetail.vue?vue&type=script&lang=js&"
export * from "./cgwcDetail.vue?vue&type=script&lang=js&"
import style0 from "./cgwcDetail.vue?vue&type=style&index=0&id=7b167874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b167874",
  null
  
)

export default component.exports